import Isotope from 'isotope-layout';
var imagesLoaded = require('imagesloaded');

let masonry = {
    instanceIsotope:null,
    init() {
        imagesLoaded( '.grid', () => {
            this.initIsotope()
        });

        // $('.grid').imagesLoaded().done( ()=> {
        //   this.initIsotope()
        // });


        $('.filtre li').click((el)=>{
            var slug = $(el.currentTarget).attr('id');
            $('.filtre li').removeClass('active');
            $(el.currentTarget).addClass('active');
            if(slug == "all"){
                this.instanceIsotope.arrange({
                    filter: '*'
                });
            }else{
                this.instanceIsotope.arrange({
                    filter: '.'+slug
                });
            }
        })

    },
    initIsotope(){
        this.instanceIsotope = new Isotope('.grid', {
            // options
            itemSelector: '.grid-item',
            percentPosition: true,

            masonry: {
              // use outer width of grid-sizer for columnWidth
              columnWidth: '.grid-sizer',
              gutter: 20
            }
        });
    }
}

export default masonry;
